module.exports = __webpack_public_path__ + "media/images/b2b_admin/preview_trip_details-6c64582a22e73f68dc1c4d9bd5dad14d.gif";